<div *ngFor="let contentElement of blogHeader?.contentElements" [ngClass]="contentElement.containerClasses">
    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
</div>
